import React from 'react';

import { useNavigate } from 'react-router-dom';

import { reverse } from 'named-urls';

import Record from 'ui/Record/Record';

import { Button } from 'components/Button';
import { MainHeader } from 'components/MainHeader/MainHeader';

import routes from 'core/routes';

import { useNavBarHeight } from 'utils/hooks/navbar';

import TeamList from './components/TeamList';

const Teams: React.FunctionComponent = (): React.ReactElement => {
  const navigate = useNavigate();
  const navBarHeight = useNavBarHeight();

  return (
    <Record
      navBarHeight={navBarHeight}
      Content={(onError) => <TeamList onError={onError} />}
      Header={
        <MainHeader
          title="Teams"
          breadcrumbs={[
            { label: 'Organisation', link: '' },
            { label: 'Teams', link: routes.dashboard.settings.teams.toString() },
          ]}
          action={
            <Button
              onClick={() =>
                navigate(
                  reverse(routes.dashboard.settings.teams.details, {
                    teamId: 'new',
                  })
                )
              }
              variant="contained"
              size="large"
            >
              New Team
            </Button>
          }
        />
      }
    />
  );
};

export default Teams;
